import { render, staticRenderFns } from "./platLogin.vue?vue&type=template&id=036d7aba&scoped=true"
import script from "./platLogin.vue?vue&type=script&lang=js"
export * from "./platLogin.vue?vue&type=script&lang=js"
import style0 from "./platLogin.vue?vue&type=style&index=0&id=036d7aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d7aba",
  null
  
)

export default component.exports